import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/product",
    name: "product",
    component: dashboard,
    redirect: {
      name: "productCode"
    },
    children: [
      {
        path: "productCode",
        name: "productCode",
        meta: { title: "21位码查询" },
        component: () =>
          import("@/views/product/baseProductCode/productCode21.vue"),
        children: []
      },
      {
        path: "productCodeRule",
        name: "productCodeRule",
        meta: { title: "产品编码规则" },
        component: () =>
          import("@/views/product/baseProductCode/productCodeRule.vue"),
        children: []
      }
    ]
  }
];
